module.exports = __webpack_public_path__ + "images/2c6d97fd309945fb767b5d2a815108ff.png";